import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "text-red"
}
const _hoisted_3 = { class: "input-wrapper" }
const _hoisted_4 = { class: "text-input" }
const _hoisted_5 = { class: "actions d-flex lh-primary" }
const _hoisted_6 = { class: "text-left flex-fill d-flex flex-wrap" }
const _hoisted_7 = {
  key: 0,
  class: "text-danger ml-2 pt-1"
}
const _hoisted_8 = { class: "text-right d-flex flex-wrap justify-content-end align-items-center" }
const _hoisted_9 = {
  key: 0,
  class: "mr-2"
}

import {
    ref,
    computed,
    watch,
    inject,
    onMounted,
    onBeforeUnmount,
    WritableComputedRef,
    nextTick,
    provide,
    ComputedRef, Ref
} from 'vue';
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import {
    OPERATOR_EMOJI_SHORT_TO_UNICODE_MAP
} from "~/operatorApplication/ts/OperatorApplicationEmojiMap";
import {AbstractApiResult} from "~/core-ui/ts/request/AbstractApiResult";
import OperatorApplicationUploadHelper from "~/operatorApplication/ts/request/OperatorApplicationUploadHelper";
import {__} from "~/ts/library/Translate";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {
    CHAT_SEND_MESSAGE_SHORTCUT_CTRL_ENTER,
    CHAT_SEND_MESSAGE_SHORTCUT_ENTER, CHAT_SEND_MESSAGE_SHORTCUT_META_ENTER,
    OperatorApplicationConfigInstance
} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import OperatorApplicationAutomaticTemplates
    from "~/operatorApplication/ts/service/dialog/OperatorApplicationAutomaticTemplates";
import OperatorApplicationTextareaSuggestInterface
    from "~/operatorApplication/vue/dialogs/dialog/suggestedTemplates/OperatorApplicationTextareaSuggestInterface";
import Random from "~/ts/library/Random";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {
    MOUSEDOWN_EVENT_CUSTOM_DATA_KEY,
    MouseDownEventCustomDataInterface,
    MouseDownItemTemplatesItemInterface
} from "~/operatorApplication/ts/platform/ContextMenuHelper";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {
    REMOVE_FROM_BUDDY_LIST, SHORTCUT_CLOSE_DIALOG,
    SHORTCUT_FOCUS_ON_TEXTAREA,
    SHORTCUT_INSERT_MESSAGE_TEMPLATE,
    SHORTCUT_OPEN_LINK_FROM_CLIENT_INFO, SHORTCUT_RITHORIC_QUESTION,
    SHORTCUT_SEND_TAB, SHORTCUT_START_BOT
} from "~/operatorApplication/ts/service/shortcuts/ShortcutsList";
import axios from "axios";
import Delay from "~/ts/library/Delay";
import OperatorNodeRequest from "~/operatorApplication/ts/service/comet/OperatorNodeRequest";
import ObjectHelper from "~/ts/library/ObjectHelper";
import {CLIENT_STATUS_OFFLINE} from "~/operatorApplication/ts/data/ClientStatus";
import DateHelper from "~/ts/library/Date";
import OpenApiResult from "~/ts/library/openApi/OpenApiResult";
import {
    KnowledgeBaseEssence, KnowledgeBaseEssenceArticle, KnowledgeBaseEssenceGroup,
    OperatorApplicationDialogTextareaModelInterface, OperatorApplicationDialogTextareaModelKnowledgeBaseInterface,
    USE_OPERATOR_SUGGEST_EVENT, UseOperatorMessageSuggestEventPayloadInterface
} from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaModelInterface";
import OperatorApplicationDialogTextareaAction
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaAction.vue";
import OperatorApplicationSendDelayedMessageDialog
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationSendDelayedMessageDialog.vue";
import LcabApiResult from "~/cabinet/ts/api/LcabApiResult";
import {isInSelectedSectionInjectionKey} from "~/operatorApplication/vue/layout/OperatorApplicationSectionInjection";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import useActivated from "~/ts/vuePlugins/useActivated";
import OperatorApplicationDialogTextareaExposeInterface
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaExposeInterface";
import TextInputWithVariables from "~/cabinet/vue/interface/tinymce/TextInputWithVariables.vue";
import OperatorApplicationHtmlify from "~/operatorApplication/vue/misc/OperatorApplicationHtmlify.vue";
import StringHelper from "~/ts/library/StringHelper";
import TextInputWithVariablesExposeInterface
    , {
    TextInputWithVariablesEnterEventInterface
} from "~/cabinet/vue/interface/tinymce/TextInputWithVariablesExposeInterface";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import {SendTabShortcutPayloadInterface} from "~/operatorApplication/ts/service/shortcuts/CustomShortcutTypes";
import {sendTab} from "~/operatorApplication/ts/service/dialog/OperatorApplicationSendTab";
import {LINK_REGEXP} from "~/core-ui/vue/ui/CoreUiHtmlifyHelper";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import Events from "~/ts/library/Events";
import getCurrentDialogOfClient from "~/operatorApplication/ts/service/buddyList/getCurrentDialogOfClient";
import {TextareaButtonInjectionKey} from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import StartBotButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/StartBotButton.vue";
import CopilotCommandButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/CopilotCommandButton.vue";
import MessageTemplateButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/MessageTemplateButton.vue";
import SendPaymentTabButton
    from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/sendTab/SendPaymentTabButton.vue";
import SendFormTabButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/sendTab/SendFormTabButton.vue";
import SendHtmlTabButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/sendTab/SendHtmlTabButton.vue";
import RequestRateButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/RequestRateButton.vue";
import KnowledgeBaseButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/KnowledgeBaseButton.vue";
import CloseDialogButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/CloseDialogButton.vue";
import RithoricQuestionButton
    from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/RithoricQuestionButton.vue";
import ToggleMuteButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/ToggleMuteButton.vue";
import UploadButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/UploadButton.vue";
import EmojiButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/EmojiButton.vue";
import AttachmentsList from "~/operatorApplication/vue/dialogs/dialog/textarea/AttachmentsList.vue";
import ReplyTo from "~/operatorApplication/vue/dialogs/dialog/textarea/ReplyTo.vue";
import AnswerChannelSourceSelect from "~/operatorApplication/vue/dialogs/dialog/textarea/AnswerChannelSourceSelect.vue";
import TextareaButtonInterface, {
    CLOSE_DIALOG_BUTTON_ID,
    COPILOT_BUTTON_ID, COPILOT_SUGGEST_TOGGLE_BUTTON_ID,
    EMOJI_BUTTON_ID,
    KNOWLEDGE_BASE_BUTTON_ID,
    MESSAGES_TEMPLATES_BUTTON_ID, REQUEST_CONTACT_BUTTON_ID,
    REQUEST_RATE_BUTTON_ID, REQUEST_TIP_BUTTON_ID,
    RITHORIC_QUESTION_BUTTON_ID,
    SEND_FORM_TAB_BUTTON_ID,
    SEND_HTML_TAB_BUTTON_ID,
    SEND_PAYMENT_FORM_TAB_BUTTON_ID,
    START_BOT_BUTTON_ID,
    TOGGLE_MUTE_BUTTON_ID, TRANSLATE_BUTTON_ID,
    UPLOAD_FILE_BUTTON_ID,
    VOICE_MESSAGE_BUTTON_ID, VOICE_TRANSCRIBE_BUTTON_ID
} from "~/operatorApplication/vue/dialogs/dialog/textarea/TextareaButtonInterface";
import TextareaButtons from "~/operatorApplication/vue/dialogs/dialog/textarea/TextareaButtons.vue";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import VoiceMessageButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/VoiceMessageButton.vue";
import OperatorApplicationSuggestedTemplates
    from "~/operatorApplication/vue/dialogs/dialog/suggestedTemplates/OperatorApplicationSuggestedTemplates.vue";
import TranslateButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/TranslateButton.vue";
import getTranslateCommandParams from "~/operatorApplication/ts/service/copilot/getTranslateCommandParams";
import {CopilotCommandRunner} from "~/operatorApplication/ts/service/copilot/CopilotCommandRunner";
import {TRANSLATE_COMMAND_ID} from "~/operatorApplication/ts/service/copilot/constants";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import startBot from "~/operatorApplication/ts/service/dialog/startBot";
import VoiceRecorder from "~/operatorApplication/vue/dialogs/dialog/textarea/VoiceRecorder.vue";
import VoiceTranscribeMessageButton
    from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/VoiceTranscribeMessageButton.vue";
import RequestTipButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/RequestTipButton.vue";
import getLastClientDialogStatus from "~/operatorApplication/ts/data/getLastClientDialogStatus";
import {OPERATOR_APPLICATION_LOAD_DELAYED_MESSAGES_EVENT} from "~/operatorApplication/ts/service/comet/Constants";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import {ContentVariableInterface} from "~/cabinet/vue/interface/ContentVariableInterface";
import getOperatorDisplayName from "~/operatorApplication/ts/service/operators/getOperatorDisplayName";
import prepareTextForSearch from "~/operatorApplication/ts/service/dialog/prepareTextForSearch";
import RequestContactButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/RequestContactButton.vue";
import CopilotSuggestButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/CopilotSuggestButton.vue";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";

import OperatorGetParamsSiteAnswerChannelSourceIdOpenApiModel = OperatorApplicationApi.OperatorGetParamsSiteAnswerChannelSourceIdOpenApiModel;
import OnlineMessageContentOpenApiModel = OperatorApplicationApi.OnlineMessageContentOpenApiModel;


import Dictionary from "~/ts/library/Dictionary";
import {defineComponent, reactive} from "vue";

let modelStore: Dictionary<OperatorApplicationDialogTextareaModelInterface> = reactive({});

let lastFocusedIsRealClient = false;

const __default__ = defineComponent({
    name: "OperatorApplicationDialogTextarea"
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    client: {},
    templatesAndSendOnly: { type: Boolean },
    sendFunction: { type: Function },
    unpinAllButtons: { type: Boolean },
    suggestTemplatesAtBottom: { type: Boolean }
  },
  emits: ["keyup", "input", "send", "toggle-mute"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

function isRealClient(): boolean {
    return props.client.crossOperatorConversationParams?.parentUsername === undefined;
}

function onFocused() {
    lastFocusedIsRealClient = isRealClient();
}

let textareaButtonsList: ComputedRef<TextareaButtonInterface[]> = computed(() => {
    let result: TextareaButtonInterface[] = [];
    if (!CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(props.client)) {
        result.push(
            {
                id: COPILOT_BUTTON_ID,
                component: CopilotCommandButton,
                withDropdown: true,
                availableInCabinet: true
            }
        );
        if (!props.templatesAndSendOnly) {
            if (isCopilotSuggestEnabled.value) {
                result.push({
                    id: COPILOT_SUGGEST_TOGGLE_BUTTON_ID,
                    component: CopilotSuggestButton,
                    isRightSide: false,
                    hideInDropdown: true,
                    alwaysPinned: true,
                    availableInCabinet: false
                });
            }
        }
        result.push(
            {
                id: MESSAGES_TEMPLATES_BUTTON_ID,
                component: MessageTemplateButton
            }
        );
        if (!props.templatesAndSendOnly) {
            result.push({
                id: TRANSLATE_BUTTON_ID,
                component: TranslateButton,
                isRightSide: true,
                hideInDropdown: isTranslateEnabled.value,
                alwaysPinned: isTranslateEnabled.value,
                availableInCabinet: true
            });
            if (selectedAnswerChannel.value?.isMainChat) {
                result.push(
                    {
                        id: SEND_PAYMENT_FORM_TAB_BUTTON_ID,
                        component: SendPaymentTabButton
                    },
                    {
                        id: SEND_FORM_TAB_BUTTON_ID,
                        component: SendFormTabButton
                    },
                    {
                        id: SEND_HTML_TAB_BUTTON_ID,
                        component: SendHtmlTabButton
                    },
                    {
                        id: REQUEST_RATE_BUTTON_ID,
                        component: RequestRateButton
                    },
                    {
                        id: REQUEST_TIP_BUTTON_ID,
                        component: RequestTipButton
                    },
                    {
                        id: REQUEST_CONTACT_BUTTON_ID,
                        component: RequestContactButton
                    },
                    {
                        id: START_BOT_BUTTON_ID,
                        component: StartBotButton
                    },
                    {
                        id: KNOWLEDGE_BASE_BUTTON_ID,
                        component: KnowledgeBaseButton
                    }
                );
            }
            if (!editedMessage.value) {
                result.push(
                    {
                        id: CLOSE_DIALOG_BUTTON_ID,
                        component: CloseDialogButton,
                        isRightSide: true
                    },
                    {
                        id: RITHORIC_QUESTION_BUTTON_ID,
                        component: RithoricQuestionButton,
                        isRightSide: true
                    }
                );
            }
        }
    } else {
        if (!props.templatesAndSendOnly) {
            result.push({
                id: TOGGLE_MUTE_BUTTON_ID,
                component: ToggleMuteButton,
                isRightSide: true
            });
        }
    }
    result.push(
        {
            id: VOICE_MESSAGE_BUTTON_ID,
            component: VoiceMessageButton,
            isRightSide: true
        },
        {
            id: VOICE_TRANSCRIBE_BUTTON_ID,
            component: VoiceTranscribeMessageButton,
            isRightSide: true
        },
        {
            id: UPLOAD_FILE_BUTTON_ID,
            component: UploadButton,
            isRightSide: true,
            availableInCabinet: true
        },
        {
            id: EMOJI_BUTTON_ID,
            component: EmojiButton,
            isRightSide: true,
            withDropdown: true,
            availableInCabinet: true
        }
    );

    if (OperatorAccountStore.isCabinetIframe) {
        result = result.filter(item => item.availableInCabinet);
    }

    return result;
});


let isInSelectedSection = inject(isInSelectedSectionInjectionKey);
let isRouteActivated = useActivated();
let isActivated = computed(() => {
    return isRouteActivated.value && isInSelectedSection.value
});

let voiceRecordVisible = ref(false);
let transcribeModeEnabled = ref(false);

let uploadCount = ref(0);
let selectedSuggest = ref<OperatorApplicationTextareaSuggestInterface>();

let delaySendDialog = ref<{
    visible: boolean
}>();
let editedMessage = ref<OperatorApplicationApi.OperatorApplicationMessageOpenApiModel>();
let textareaSuggests = ref<OperatorApplicationTextareaSuggestInterface[]>([]);
//let upload = ref<Upload>(null);
let textarea = ref<TextInputWithVariablesExposeInterface>(null);

let username = computed(() => {
    return props.client.username;
});

let isTranslateEnabled = computed(() => ClientUserdataStore.isTranslateEnabled(username.value));

let isCopilotSuggestEnabled = computed(() => props.client.copilot.enabled);


watch(username, (newUsername: string, oldUsername: string) => {
    usernameChanged(newUsername, oldUsername);
});


let model: WritableComputedRef<OperatorApplicationDialogTextareaModelInterface> = computed({
    get: () => {
        if (!modelStore[getModelKeyByUsername(props.client.username)]) {
            resetModel();
        }
        return modelStore[getModelKeyByUsername(props.client.username)];
    },
    set: value => {
        modelStore[getModelKeyByUsername(props.client.username)] = value;
    }
});

function setReplyToMessageId(messageId?: number, fallbackText?: string) {
    if (messageId) {
        let message = ClientUserdataStore.getMessagesByUsername(username.value).find(message => message.id == messageId);
        if (message || fallbackText) {
            model.value.replyTo = {
                messageId,
                textPreview: message?.text ?? fallbackText
            };
            focusTextarea();
            return;
        }
    }
    model.value.replyTo = null;
    focusTextarea();
}


function getModelKeyByUsername(username: string) {
    return `${OperatorAccountStore.login.value}/${username}`;
}

function usernameChanged(newUsername?: string, oldUsername?: string) {
    if (newUsername) {
        let channels = availableAnswerChannels.value;
        let channelId = model.value.answerChannelId;
        if (!channels.find(item => item.id === channelId)) {
            if (channels[0]) {
                model.value.answerChannelId = channels[0].id;
            }
        }
        focusTextarea();
    }

    if (oldUsername) {
        let model = modelStore[getModelKeyByUsername(oldUsername)];
        if (model) {
            if ((!model.text || !model.text.length) && !model.files.length) {
                delete modelStore[getModelKeyByUsername(oldUsername)];
            }
        }
    }
}

function listenShortcut(event: string, callback: (payload: any) => void) {
    addDisposableEvent(OperatorApplicationEventManager.addEventListener(
        event,
        (payload: any) => {
            if (isActivated.value) {
                callback(payload);
            }
        }
    ));
}

onMounted(() => {
    usernameChanged(props.client.username);
    listenShortcut(SHORTCUT_FOCUS_ON_TEXTAREA, () => {
        textarea.value.focus();
    });

    listenShortcut(SHORTCUT_CLOSE_DIALOG, () => {
        closeDialog(false);
    });

    listenShortcut(SHORTCUT_RITHORIC_QUESTION, () => {
        markAsRithoric(false);
    });

    listenShortcut(REMOVE_FROM_BUDDY_LIST, () => {
        let dialogStatus = getLastClientDialogStatus(props.client);
        if (dialogStatus?.isHaveNoAnswer !== true) {
            OperatorApplicationBuddyList.removeClients([props.client.username]);
        }
    });
    listenShortcut(SHORTCUT_INSERT_MESSAGE_TEMPLATE, (templateId: string) => {
        if (site.value) {
            let template = OperatorAccountStore.getMessageTemplatesBySite(site.value.id).templates.find(template => template.id == templateId);
            if (template) {
                onTemplateSelect(template, true);
            } else {
                AbstractApiResult.showError(`Выбранный шаблон в данный момент не доступен для сайта ${site.value.title}`);
            }
        }
    });
    listenShortcut(SHORTCUT_START_BOT, (botId: string) => {
        if (site.value) {
            let bot = site.value.bots.find(bot => bot.id == botId);
            if (bot) {
                startBot(props.client.username, botId);
            } else {
                AbstractApiResult.showError(`Выбранный бот в данный момент не доступен для сайта ${site.value.title}`);
            }
        }
    });
    listenShortcut(SHORTCUT_OPEN_LINK_FROM_CLIENT_INFO, (fieldName: string) => {
        let field = props.client.fields[fieldName];
        if (typeof field == "string") {
            let links = field.match(LINK_REGEXP);
            if (links && links.length) {
                OperatorApplicationPlatformFactory.openExternal(links[0]);
            }
        }
    });
    listenShortcut(SHORTCUT_SEND_TAB, (payload: SendTabShortcutPayloadInterface) => {
        sendTab(props.client.username, payload.tabId, payload.showType);
    });
    emitInput();
});


onBeforeUnmount(() => {
    usernameChanged(null, props.client.username);
});

watch(computed(() => model.value.text), async () => {
    setTextareaSuggests();
    try {
        if (selectedAnswerChannel.value?.isMainChat) {
            await Delay.make(1000, `typePublish_${props.client.username}`, false);
            let body: CometOperatorApplication.CometOperatorTypingBodyOpenApiModel = {
                text: model.value.text,
                operator: OperatorAccountStore.login.value,
                username: props.client.username,
                siteId: props.client.siteId,
                orgId: OperatorAccountStore.data.value.orgId,
                clientId: props.client.clientId
            };
            (new OperatorNodeRequest("/operatorTyping"))
                .setBody(body)
                .send();
        }
    } catch (e) {
        return;
    }
    emits("keyup");
});

let placeholder = computed(() => {
    if (!props.templatesAndSendOnly) {
        if (!props.client.integration && props.client.type.isReal) {
            if (props.client.status == CLIENT_STATUS_OFFLINE) {
                let lastActivity = ``;
                if (!props.client.integration && props.client.visitStatistic) {
                    let lastVisitStopDateTime = props.client.visitStatistic.lastVisitStopDateTime;
                    if (lastVisitStopDateTime) {
                        lastVisitStopDateTime *= 1000;
                        let now = DateHelper.nowEverySecond;//(new Date()).getTime();
                        let delta = now - lastVisitStopDateTime;
                        if (delta > 0) {
                            lastActivity = DateHelper.secondsFormatToClosestFloor(Math.ceil(delta / 1000));
                            lastActivity = ` (${__('%s назад', lastActivity)})`;
                        }
                    }
                }
                return __('Посетитель покинул сайт') + lastActivity;
            } else if (!props.client.isOnTab) {
                return __('Посетитель на другой вкладке');
            }
        }
    }
    return __('Новое сообщение');
});

function resetModel() {
    let prevModel = modelStore[getModelKeyByUsername(props.client.username)];
    model.value = {
        answerChannelId: prevModel ? prevModel.answerChannelId : null,
        text: null,
        replyTo: null,
        files: [],
        knowledgeBase: [],
        answerChannelSourceId: prevModel ? prevModel.answerChannelSourceId : null,
        botId: null,
        templateId: null,
        suggestedAnswerId: null
    };
}


watch(model, () => emitInput(), {deep: true});

function emitInput() {
    emits("input", model.value);
}

function getChannelDescr(channel: OperatorApplicationApi.OperatorApplicationAnswerChannelOpenApiModel): string {
    let result = channel.descr;
    if (channel.isMainChat) {
        if (props.client.integration) {
            let platform = OperatorAccountStore.integrationPlatformDictionary.value[props.client.integration.platformId];
            if (platform) {
                result = __("Интеграция с %s", platform.descr);
            }
        }
    } else {
        if (channel.hasSource) {
            let sources = sourcesDictionaryByChannelId.value[channel.id];
            if (sources) {
                let aggregationPlatformDescrList: string[] = [];
                for (let source of sources) {
                    if (source.aggregationPlatformDescr) {
                        toggleArrayElement(aggregationPlatformDescrList, source.aggregationPlatformDescr, true);
                    }
                }
                if (aggregationPlatformDescrList.length) {
                    result = aggregationPlatformDescrList.join(", ") + ` через ${result}`;
                }
            }
        }
    }
    return result;
}

let sourcesDictionaryByChannelId = computed(() => {
    let result: Dictionary<OperatorGetParamsSiteAnswerChannelSourceIdOpenApiModel[]> = {};
    if (site.value) {
        for (let source of site.value?.answerChannelSourceIds) {
            let answerChannelId = source.answerChannelId;
            if (!result[answerChannelId]) {
                result[answerChannelId] = [];
            }
            result[answerChannelId].push(source);
        }
    }
    return result;
})

let availableAnswerChannels = computed(() => {
    let channels: OperatorApplicationApi.OperatorApplicationAnswerChannelOpenApiModel[] = OperatorAccountStore.data.value.answerChannels;
    return channels.filter(
        item => {
            if (props.client.availableAnswerChannelIds.includes(item.id)) {
                if (!item.hasSource || site.value?.answerChannelSourceIds.find(source => source.answerChannelId == item.id)) {
                    return true;
                }
            }
            return false;
        }
    );
});

function focusTextarea() {
    textarea.value?.focus();
}

let isReadyToSend = computed(() => {
    let value = model.value;
    let result = (value.answerChannelId && value.text && value.text.trim().length > 0) || value.files.length > 0 || value.knowledgeBase.length > 0;
    if (result) {
        if (translationEnabledAndInProgress.value) {
            result = false;
        }
    }
    return result;
});

let selectedAnswerChannel = computed(() => {
    if (editedMessage.value) {
        return {
            id: "edit",
            descr: "Редактирование",
            hasSource: false,
            isComment: false,
            isMainChat: false,
            isPaid: false,
            messageTypeId: null
        };
    }
    let result = availableAnswerChannels.value.find(item => item.id == model.value.answerChannelId);
    if (!result) {
        if (availableAnswerChannels.value.length > 0) {
            result = availableAnswerChannels.value[0];
            model.value.answerChannelId = result.id;
        }
    }
    return result;
});

function uploadOnChange(file: { response: any }) {
    if (file.hasOwnProperty("response")) {
        uploadCount.value--;
        if (file.response && file.response.code === 1 && file.response.data) {
            let data = file.response.data;
            let name = data.filename;
            let id = data.id;
            if (id) {
                if (!name) {
                    name = "file";
                }
                model.value.files.push({
                    id,
                    name,
                    url: data.url,
                    size: data.size
                });
            }
        } else {
            let error = file.response ? file.response.descr : "Не удалось загрузить файл";
            AbstractApiResult.showError(error);
        }
    } else {
        uploadCount.value++;
    }
}

function getTextForSend(): string {
    let text = model.value.text?.trim();
    if (typeof text == "string" && text.length) {
        text = text.replace(/:[\w_]+:/g, function replacer(match) {
            let unicode = OPERATOR_EMOJI_SHORT_TO_UNICODE_MAP[match];
            return unicode ? unicode : match;
        });
        return text;
    }
    return '';
}

let sendOnEnter = computed(() => {
    return OperatorApplicationConfigInstance.chatSendMessageShortcut == CHAT_SEND_MESSAGE_SHORTCUT_ENTER;
});

let sendOnCtrlEnter = computed(() => {
    return OperatorApplicationConfigInstance.chatSendMessageShortcut == CHAT_SEND_MESSAGE_SHORTCUT_CTRL_ENTER;
});

let sendOnMetaEnter = computed(() => {
    return OperatorApplicationConfigInstance.chatSendMessageShortcut == CHAT_SEND_MESSAGE_SHORTCUT_META_ENTER;
});


function onPressEnter(payload: TextInputWithVariablesEnterEventInterface) {
    let isSendOnEnter = sendOnEnter.value;
    let isSendOnCtrlEnter = sendOnCtrlEnter.value;
    let isSendOnMetaEnter = sendOnMetaEnter.value;
    let e = payload.event;
    if (!isSendOnEnter) {
        if (!editedMessage.value && selectedSuggest.value) {
            if (selectSuggestedTemplate()) {
                e?.preventDefault();
                return;
            }
        }
    }
    let isSendMessage = (isSendOnEnter && (!payload.shift && !e?.altKey && !e?.ctrlKey && !e?.metaKey)) || (isSendOnCtrlEnter && e?.ctrlKey) || (isSendOnMetaEnter && e?.metaKey);
    if (isSendMessage) {
        e?.preventDefault();
        if (editedMessage.value) {
            saveEdit();
        } else {
            sendMessage();
        }
    }
}

function selectSuggestedTemplate(): boolean {
    if (selectedSuggest.value && textareaSuggests.value.length) {
        onSuggestedTemplateSelect(selectedSuggest.value);
        return true;
    }
    return false;
}

async function saveEdit() {
    if (!selectSuggestedTemplate()) {
        if (isReadyToSend.value) {
            if (editedMessage.value.id) {
                let content: OperatorApplicationApi.OperatorMessageEditContentOpenApiModel = {
                    text: getTextForSend(),
                    attachedFiles: getAttachedFiles(),
                    knowledgeBaseArticles: getAttachedKnowledgeBaseArticles(),
                };
                let p: OperatorApplicationApi.OperatorMessageEditOpenApiModel = {
                    username: props.client.username,
                    content,
                    messageId: editedMessage.value.id
                };

                let previousState = ObjectHelper.jsonClone(editedMessage.value);
                editedMessage.value.id = null;
                editedMessage.value.temporaryId = previousState.id as any;

                try {
                    let result = await (new OperatorApiRequest({
                        url: "/message/edit",
                        p,
                        silent: true
                    })).send();
                    if (!result.showMessageOnError()) {
                        if (editedMessage.value.isDelayed) {
                            OperatorApplicationEventManager.emit(OPERATOR_APPLICATION_LOAD_DELAYED_MESSAGES_EVENT, props.client.username);
                        }
                        cancelEdit();

                    }
                } catch (e) {
                }
                try {
                    editedMessage.value.id = previousState.id;
                } catch (e) {

                }

            }
        }
    }
}

function getAttachedFiles(): OperatorApplicationApi.MessageTemplateAttachmentOpenApiModel[] {
    return model.value.files.map(file => ({
        id: file.id ? file.id : undefined,
        url: file.url ? file.url : undefined,
        size: file.size ? file.size : undefined,
        filename: file.name ? file.name : undefined
    }))
}

function getAttachedKnowledgeBaseArticles(): OperatorApplicationApi.OperatorApplicationMessageKnowledgeBaseArticleAttachmentOpenApiModel[] {
    return model.value.knowledgeBase
        .map(item => ({
            registerId: item.registerId,
            articleId: item.essence == KnowledgeBaseEssenceArticle ? item.id : undefined,
            groupId: item.essence == KnowledgeBaseEssenceGroup ? item.id : undefined,
        }));
}

async function showDelaySendDialog() {
    if (!OperatorAccountStore.showFreeDialogForSite(site.value?.id)) {
        delaySendDialog.value = {
            visible: true
        };
    }
}

async function delaySend(timestamp: number) {
    delaySendDialog.value = null;
    sendMessage(timestamp);
}

let translationState: Ref<"inProgress" | "done" | null> = ref(null);
let translationEnabledAndInProgress = computed(() => translationState.value == "inProgress" && isTranslateEnabled.value);
let lastTranslatedText: string;

async function isTranslateNeeded(): Promise<boolean> {
    let result = false;
    if (isTranslateEnabled.value) {
        if (translationState.value == "done" && lastTranslatedText != model.value.text) {
            translationState.value = null;
        }
        if (translationState.value == "inProgress") {
            result = true;
        } else if (translationState.value != "done") {
            translationState.value = "inProgress"
            let p: OperatorApplicationApi.OperatorCopilotCommandOpenApiModel = {
                type: TRANSLATE_COMMAND_ID,
                params: getTranslateCommandParams(props.client, model.value.text)
            };
            let translationResult = await CopilotCommandRunner.exec({
                username: props.client.username,
                command: p,
                onResult: response => {
                    let sameText = response === model.value.text;
                    model.value.text = lastTranslatedText = response;
                    textarea.value.moveCursorToEnd();
                    translationState.value = "done";
                    if (sameText) {
                        sendMessage();
                    }
                }, onTimeout: () => {
                    showCopilotTimeoutError();
                    translationState.value = null;
                }
            });
            if (translationResult.showMessageOnError()) {
                translationState.value = null;
            }
            result = true;
        } else if (translationState.value == "done") {
            translationState.value = null;
            result = false;
        }
        lastTranslatedText = null;
    }
    return result;
}


async function sendMessage(delayTimestamp?: number, sticker?: OperatorApplicationApi.OperatorApplicationStickerOpenApiModel) {
    if (!selectSuggestedTemplate()) {
        if (isReadyToSend.value || sticker) {
            if (!delayTimestamp && !props.sendFunction && model.value.text) {
                if (isTranslateEnabled.value) {
                    if (await isTranslateNeeded()) {
                        return;
                    }
                }
            }
            let sendByModel = !sticker;
            let channel = selectedAnswerChannel.value;
            let content: OperatorApplicationApi.OperatorMessageSendContentOpenApiModel = sticker ? {
                stickerId: sticker.id,
                answerChannelId: model.value.answerChannelId
            } : {
                text: getTextForSend(),
                attachedFiles: getAttachedFiles(),
                knowledgeBaseArticles: getAttachedKnowledgeBaseArticles(),
                answerChannelId: model.value.answerChannelId,
                botId: model.value.botId,
                templateId: model.value.templateId,
                suggestId: model.value.suggestedAnswerId,
            };
            if (model.value.answerChannelSourceId) {
                content.answerChannelSourceId = model.value.answerChannelSourceId;
            }
            if (props.sendFunction) {
                props.sendFunction(content);
            } else {
                let username = props.client.username;
                let p: OperatorApplicationApi.OperatorMessageSendOpenApiModel = {
                    username,
                    content,
                    replyToMessageId: model.value.replyTo ? model.value.replyTo.messageId : undefined,
                    temporaryId: Random.uid(),
                    dateTime: delayTimestamp ? delayTimestamp : undefined
                };

                let modelValue = model.value;

                let tempMessage: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel;
                if (!delayTimestamp) {
                    tempMessage = addMessageToHistory(p, sticker);
                }
                emits("send");
                if (sendByModel) {
                    resetModel();
                }
                let error = true;
                let errorDescr: string;
                try {
                    let result = await (new OperatorApiRequest({
                        url: "/message/send",
                        p,
                        silent: !delayTimestamp,
                        silentError: true
                    })).send();
                    error = !result.isSuccess;
                    if (error) {
                        errorDescr = result.descr;
                    } else {
                        if (delayTimestamp) {
                            (new LcabApiResult({
                                code: 1,
                                descr: __("Отложенное сообщение успешно создано"),
                                data: {}
                            })).showMessage();
                        }
                    }
                } catch (e) {
                    OperatorApplicationPlatformFactory.notifications.show({
                        title: __("Не удалось отправить сообщение"),
                        text: __("Перейти к чату") + ": " + props.client.displayDescr,
                        click: () => {
                            OperatorApplicationBuddyList.openClientByUsername(props.client.username)
                        }
                    })
                    errorDescr = "Ошибка, попробуйте повторить";
                }
                if (error) {
                    (new OpenApiResult({
                        result: null,
                        error: {code: 0, descr: errorDescr},
                        success: false
                    })).showMessage();
                    if (sendByModel) {
                        model.value = modelValue;
                    }
                    if (errorDescr && tempMessage) {
                        tempMessage = ObjectHelper.jsonClone(tempMessage);
                        tempMessage.error = errorDescr;
                        ClientUserdataStore.addMessage({message: tempMessage});
                    }
                } else {
                    if (content.text && content.text.length) {
                        if (channel?.isMainChat && !CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(props.client)) {
                            OperatorApplicationAutomaticTemplates.addTemplate([props.client.siteId], content.text);
                        }
                    }
                }
            }
        }
    }
}

let currentDialog = computed(() => {
    return getCurrentDialogOfClient(props.client);
});

function addMessageToHistory(p: OperatorApplicationApi.OperatorMessageSendOpenApiModel, sticker?: OperatorApplicationApi.OperatorApplicationStickerOpenApiModel): CometOperatorApplication.OperatorApplicationMessageOpenApiModel {
    if (p.temporaryId) {
        let messageTypeId = selectedAnswerChannel.value?.messageTypeId;
        let date = new Date();
        let dialog = currentDialog.value;

        let text = p.content.text;
        if (text) {
            if (CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(props.client) && text.includes("[")) {
                for (let operator of allOperatorsAvailableForMention.value) {
                    let mentionVar = `[${operator.operator.mentionContentVariableId}]`;
                    if (text.includes(mentionVar)) {
                        text = text
                            .split(mentionVar)
                            .join(`[{url=onlinechat://open-operator/?login=${operator.operator.login}}]@${operator.operator.fio}[{/url}]`);
                    }
                }
            }
        }

        let message: CometOperatorApplication.OperatorApplicationMessageOpenApiModel = {
            id: null,
            username: p.username,
            isMentioned: false,
            content: {
                text,
                sticker: sticker ? {
                    emoji: sticker.emoji,
                    url: sticker.url,
                    isTgs: false,
                    isStaticImage: true,
                    fileName: "sticker.png"
                } : undefined
            },
            isDelayed: false,
            isAnswerable: false,
            isSystemChat: false,
            operatorsStatus: [],
            isRealOperator: true,
            operatorLogin: OperatorAccountStore.login.value,
            isSendByClient: false,
            dateTime: Math.ceil(date.getTime() / 1000),
            temporaryId: p.temporaryId,
            displayNotification: false,
            dialogId: dialog?.id,
            dialog,
            messageType: messageTypeId ? OperatorAccountStore.data.value.messageTypes.find(item => item.id == messageTypeId) : null,
            error: null,
            hasSeparateStatus: false,
            isCrossOperatorsChat: props.client.type.isCrossOperatorsChat,
            isCrossOperatorsConversationChat: props.client.type.isCrossOperatorsConversationChat,
            contacts: [],
            isRemovable: false,
            isEditable: false,
            isRemoved: false,
            isPinned: false,
            isPinable: false,
            senderInfo: {},
            tags: [],
            isReactionAvailable: false,
            isDictationUsed: false,
            isSentBySuggest: false
        };
        ClientUserdataStore.addMessage({message});
        return message;
    }
    return null;
}

let uploadAction = computed(() => {
    return (new OperatorApplicationUploadHelper())
        .setTag("operatorApplication")
        .getUrl();
});


let uploadVoiceAction = computed(() => {
    return (new OperatorApplicationUploadHelper())
        .setTag("operatorApplication")
        .setAdditionalQueryParams({
            isVoiceMessage: "1"
        })
        .setConvertTo("mp3")
        .getUrl();
});


function showFreeDialogForSite(): boolean {
    return site.value ? OperatorAccountStore.showFreeDialogForSite(site.value.id) : false;
}

let lastSelectedTemplateText: string;

async function onTemplateSelect(template: OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel, replace: boolean = false) {
    let modelValue = model.value;
    let text = modelValue.text;
    let templateText = template.html && !props.client.integration ? template.html : template.text;
    if (typeof templateText == "string") {
        if (template.hasVariablesInText) {
            let p: OperatorApplicationApi.GetMessageTextForClientOpenApiModel = {
                text: templateText,
                username: props.client.username
            }
            let result = await (new OperatorApiRequest<OperatorApplicationApi.GetMessageTextForClientResultOpenApiModel>({
                url: "/message/getTextForClient",
                p,
                silentError: true
            })).send();
            if (result.isSuccess) {
                templateText = result.data.text;
            }
        }
        if (typeof text == "string" && !replace && text.length > 0) {
            if (OperatorApplicationConfigInstance.prependTemplateToText) {
                text = templateText + " " + text;
            } else {
                text += ` ${templateText}`;
            }
        } else {
            text = templateText;
        }
        lastSelectedTemplateText = text;
        modelValue.text = text;
    } else {
        modelValue.text = null;
    }
    modelValue.templateId = template.id;

    focusTextarea();
    textarea.value?.moveCursorToEnd();
}

let isFree = computed(() => {
    return !!site.value?.isFree;
});

let isCopilotAvailableByTarif = computed(() => {
    return !!site.value?.isCopilotAvailableByTarif;
});

let preventKeyUpAndDown = ref(false);

async function setTextareaSuggests() {
    let result: OperatorApplicationTextareaSuggestInterface[] = [];
    if (preventKeyUpAndDown.value) {
        preventKeyUpAndDown.value = false;
    }
    if (!isFree.value) {
        try {
            const MAX_TEMPLATES = 10;

            if (currentMention.value) {
                await Delay.make(1, 'setSuggests', true);
                let q = currentMention.value.toLowerCase().substring(1);
                result = allOperatorsAvailableForMention.value
                    .filter(item => item.forSearch.includes(q))
                    .map(item => ({mention: item.operator}));
                if (result.length > MAX_TEMPLATES) {
                    result.splice(MAX_TEMPLATES, result.length - MAX_TEMPLATES);
                }
                if (result.length) {
                    preventKeyUpAndDown.value = true;
                }
            } else {
                await Delay.make(100, 'setSuggests', true);
                selectedSuggest.value = null;
                let text = getTextForSend();
                if (text) {
                    let search = prepareTextForSearch(StringHelper.stripBbCode(text).trim());
                    if (search.length > 2) {
                        if (OperatorApplicationConfigInstance.autoSuggestTemplates) {
                            let templatesForSearch = OperatorAccountStore.templatesForSearch.value[props.client.siteId];
                            if (templatesForSearch) {
                                let foundTemplates = OperatorApplicationAutomaticTemplates.search(search, templatesForSearch, item => item.search, undefined, MAX_TEMPLATES, false);
                                result = foundTemplates.map(item => ({template: item.template}));
                            }
                        }
                        let allowedAutoTemplates = MAX_TEMPLATES - result.length;
                        if (allowedAutoTemplates > 0) {
                            if (OperatorApplicationConfigInstance.suggestAutoRememberedTemplates) {
                                for (let autoTemplate of OperatorApplicationAutomaticTemplates.searchTemplates(props.client.siteId, search, allowedAutoTemplates).reverse()) {
                                    if (autoTemplate.text != text) {
                                        result.splice(0, 0, {autoTemplate});
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } catch (e) {
        }
    }
    textareaSuggests.value = result;
}

let lastTemplateSelectDateTime = 0;


function onSuggestedTemplateSelect(template: OperatorApplicationTextareaSuggestInterface) {
    if (Date.now() > lastTemplateSelectDateTime + 1000) {
        if (template.template) {
            onTemplateSelect(template.template, true);
        } else if (template.autoTemplate) {
            model.value.text = template.autoTemplate.text;
        } else if (template.mention) {
            textarea.value?.replaceMentionWith(`[${template.mention.mentionContentVariableId}]`);
            textareaSuggests.value = [];
        }
        focusTextarea();
        textarea.value?.moveCursorToEnd();
        lastTemplateSelectDateTime = Date.now();
    }
}

function changeSelectedSuggestedTemplate(deltaIndex: 1 | -1) {
    if (textareaSuggests.value.length) {
        let current = selectedSuggest.value;
        let newIndex = textareaSuggests.value.length - 1;
        if (current) {
            let currentIndex = textareaSuggests.value.indexOf(current);
            if (currentIndex > -1) {
                newIndex = currentIndex + deltaIndex;
                if (newIndex < 0) {
                    newIndex = textareaSuggests.value.length - 1;
                } else if (newIndex >= textareaSuggests.value.length) {
                    newIndex = 0;
                }
            }
        }
        selectedSuggest.value = textareaSuggests.value[newIndex];
    }
}

let site = computed(() => {
    return OperatorAccountStore.sitesDictionary.value[props.client.siteId];
});

function textareaMouseDown(event: MouseEvent) {
    if (site.value) {
        let templates: MouseDownItemTemplatesItemInterface[] = [];
        let siteTemplates: OperatorApplicationApi.OperatorGetParamsMessageTemplatesOpenApiModel = OperatorAccountStore.getMessageTemplatesBySite(site.value.id);
        for (let category of siteTemplates.categories) {
            templates.push({
                id: category.id,
                descr: category.descr,
                templates: []
            });
        }
        templates.push({
            id: null,
            descr: __("Вне категорий"),
            templates: []
        });
        for (let item of templates) {
            item.templates = siteTemplates.templates
                .filter(template => (!template.categoryIds && !item.id) || (template.categoryIds && template.categoryIds.includes(item.id)))
                .map(template => ({
                    id: template.id,
                    descr: template.descr
                }));
        }
        (event as any)[MOUSEDOWN_EVENT_CUSTOM_DATA_KEY] = {
            isDialogTextarea: true,
            templatesLabel: __("Шаблоны"),
            templates: templates.filter(item => item.templates.length > 0)
        } as MouseDownEventCustomDataInterface;
    }
}

function hasModifierKeys(e: KeyboardEvent) {
    return e.altKey || e.metaKey || e.ctrlKey || e.shiftKey;
}

function onDownKeyPress(e: KeyboardEvent) {
    if (!isReadyToSend.value && !editedMessage.value) {
        if (!hasModifierKeys(e)) {
            let descr = props.client.fields.descr;
            if (typeof descr == "string") {
                model.value.text = `${descr},`;
                focusTextarea();
                textarea.value?.moveCursorToEnd();
            }
        }
    } else {
        changeSelectedSuggestedTemplate(1)
    }
}

function onEscKeyPress() {
    textareaSuggests.value = [];
}


function onUpKeyPress(e: KeyboardEvent) {
    if (!isReadyToSend.value && !editedMessage.value) {
        if (!hasModifierKeys(e)) {
            let messages = ClientUserdataStore.getMessagesByUsername(props.client.username);
            for (let i = messages.length - 1; i > 0; i--) {
                if (messages[i].isEditable && messages[i].id) {
                    editMessage(messages[i]);
                    break;
                }
            }
        }
    } else {
        changeSelectedSuggestedTemplate(-1);
    }
}

function messageContentToModelValue(content: OnlineMessageContentOpenApiModel): OperatorApplicationDialogTextareaModelInterface {
    let knowledgeBase: OperatorApplicationDialogTextareaModelKnowledgeBaseInterface[] = [];
    if (content.knowledgeBaseArticles) {
        knowledgeBase.push(...content.knowledgeBaseArticles.map(article => ({
            essence: article.articleId ? KnowledgeBaseEssenceArticle as KnowledgeBaseEssence : KnowledgeBaseEssenceGroup,
            id: article.articleId ?? article.groupId,
            registerId: article.registerId,
            descr: article.descr
        })));
    }
    return {
        answerChannelId: availableAnswerChannels.value[0].id,
        text: content.text,
        knowledgeBase,
        files: content.attachments ? content.attachments.map(attachment => ({
            id: attachment.id,
            name: attachment.fileName,
            url: attachment.url,
            size: attachment.fileSize
        })) : [],
        answerChannelSourceId: null,
        botId: null,
        templateId: null,
        suggestedAnswerId: null
    };
}

function messageToModelValue(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel): OperatorApplicationDialogTextareaModelInterface {
    return messageContentToModelValue(message.content);
}

function editMessage(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    if (message.id && message.isEditable) {
        editedMessage.value = message;

        model.value = messageToModelValue(message);
        focusTextareaAndMoveCursorToEnd();
    }
}

function focusTextareaAndMoveCursorToEnd() {
    nextTick(() => {
        focusTextarea();
        textarea.value?.moveCursorToEnd();
    });
}

function cancelEdit() {
    resetModel();
    editedMessage.value = null;
}

async function onPaste(e: ClipboardEvent) {
    if (e.clipboardData && e.clipboardData.files.length) {
        if (!showFreeDialogForSite()) {
            let formData = new FormData();
            formData.append("file", e.clipboardData.files[0]);
            uploadCount.value++;
            let result = await axios.post(uploadAction.value, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            uploadOnChange({
                response: result.data
            });
        }
    }
}

let canFormatText = computed(() => {
    return !isFree.value && OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canFormatText)
})

let availableBBCodeIds = computed(() => {
    let platformId = props.client.integration?.platformId;
    if (platformId) {
        let platform = OperatorAccountStore.integrationPlatformDictionary.value[platformId];
        if (platform) {
            return platform.availableBbCode;
        }
    }
    return undefined;
});

let isShowAnswerChannelTabs = computed(() => {
    let result = true;
    if (availableAnswerChannels.value.length < 2) {
        let channel = availableAnswerChannels.value[0];
        if (!channel || channel.isMainChat) {
            result = false;
        }
    }
    return result;
});

let copilotCommandRunning = ref(false);
let copilotTimeoutError = ref(false);


function showCopilotTimeoutError() {
    if (!copilotCommandRunning.value) {
        copilotTimeoutError.value = true;
        hideCopilotTimeoutError(3000);
    }
}

async function hideCopilotTimeoutError(delay: number = 1) {
    try {
        await Delay.make(delay, "showCopilotTimeoutError " + props.client.username, true);
        copilotTimeoutError.value = false;
    } catch (e) {

    }
}

function toggleCopilotRunning(value: boolean) {
    hideCopilotTimeoutError(1);
    copilotCommandRunning.value = value;
}

function resetTextareaSelection() {
    textarea.value?.moveCursorToEnd();
}

let closeInProcess = false;

async function closeDialog(needConfirm: boolean = true) {
    if (!closeInProcess) {
        closeInProcess = true;
        try {
            if (needConfirm) {
                await ElConfirm(__('Вы уверены, что хотите завершить текущий диалог?'));
            }
            let p: OperatorApplicationApi.OperatorMessageCloseDialogOpenApiModel = {
                username: props.client.username
            };
            let result = await (new OperatorApiRequest({
                url: "/message/closeDialog",
                p
            })).send();
            result.showMessageOnError();
        } catch (e) {

        }
        closeInProcess = false;
    }
}

let markAsRithoricInProcess = false;

async function markAsRithoric(needConfirm: boolean = true) {
    if (!markAsRithoricInProcess) {
        markAsRithoricInProcess = true;
        try {
            if (needConfirm) {
                await ElConfirm(__('Помечаем вопрос как риторический?'));
            }
            let p: OperatorApplicationApi.OperatorMessageMarkAsRithoricOpenApiModel = {
                username: props.client.username
            };
            let result = await (new OperatorApiRequest({
                url: "/message/markAsRithoric",
                p
            })).send();
            result.showMessageOnError();
        } catch (e) {

        }
        markAsRithoricInProcess = false;
    }
}

function focusIfActivated() {
    if (isActivated.value) {
        let isReal = isRealClient()
        if (isReal || lastFocusedIsRealClient === isReal) {
            focusTextarea();
        }
    }
}

async function startVoiceRecord() {
    transcribeModeEnabled.value = false;
    voiceRecordVisible.value = true;
}

async function startVoiceTranscribe() {
    transcribeModeEnabled.value = true;
    voiceRecordVisible.value = true;
}

function onTranscribeResult(text: string) {
    model.value.text = model.value.text ?? "";
    if (model.value.text.length) {
        model.value.text += "\n";
    }
    model.value.text += text;
    focusTextarea();
    textarea.value.moveCursorToEnd();
}

let maxTextLength = computed(() => {
    if (selectedAnswerChannel.value?.isMainChat) {
        let platformId = props.client.integration?.platformId;
        if (platformId) {
            return OperatorAccountStore.integrationPlatformDictionary.value[platformId]?.messengerPlatformData?.maxMessageTextLength;
        }
    }
    return null;
});

var plainTextLength = computed(() => {
    let text = model.value.text ?? "";
    return StringHelper.stripBbCode(text).length;
});

let crossOperatorsGroupChat = computed(() => {
    if (props.client.type.isCrossOperatorsChat) {
        return OperatorAccountStore.crossOperatorChat.value[props.client.username]?.group;
    }
    return null;
});

let isMentionsAvailable = computed(() => {
    return !!crossOperatorsGroupChat.value || props.client.type.isCrossOperatorsConversationChat;
});

let currentMention = ref<string>();

function onMentionChange(mention?: string) {
    if (currentMention.value != mention) {
        currentMention.value = mention;
        setTextareaSuggests();
    }
}

let allOperatorsAvailableForMention = computed(() => {
    let operators: OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel[] = [];
    if (crossOperatorsGroupChat.value) {
        for (let login of crossOperatorsGroupChat.value.operatorLogins) {
            if (login !== OperatorAccountStore.login.value) {
                let operator = OperatorAccountStore.operatorsDictionary.value[login];
                if (operator) {
                    operators.push(operator);
                }
            }
        }
    } else if (props.client.type.isCrossOperatorsConversationChat) {
        let site = OperatorAccountStore.sitesDictionary.value[props.client.crossOperatorConversationParams?.parentSiteId];
        if (site) {
            operators = OperatorAccountStore.getOperatorsOfSite(site);
        }
    }
    return operators.map(operator => ({
        forSearch: operator.fio.toLowerCase() + operator.login.toLowerCase(),
        operator
    }));
});

let contentVariables = computed<ContentVariableInterface[]>(() => allOperatorsAvailableForMention.value.map(operator => ({
    id: operator.operator.mentionContentVariableId,
    descr: `@${getOperatorDisplayName(operator.operator)}`
})));

addDisposableEvent(OperatorApplicationEventManager.addEventListener(USE_OPERATOR_SUGGEST_EVENT, (p: UseOperatorMessageSuggestEventPayloadInterface) => {
    if (p.username === props.client.username) {
        if (isActivated.value) {
            let oldModel = model.value;
            model.value = messageContentToModelValue(p.suggest.content);
            model.value.suggestedAnswerId = p.suggest.id;
            if (p.send) {
                sendMessage();
                model.value = oldModel;
            }
            focusTextareaAndMoveCursorToEnd();
        }
    }
}));

addDisposableEvent(Events.addEventListener("blur", window, () => focusIfActivated()));

watch(isActivated, () => focusIfActivated());

__expose<OperatorApplicationDialogTextareaExposeInterface>({
    uploadOnChange,
    setReplyToMessageId,
    model: () => model,
    focusTextarea,
    editMessage
});

provide(TextareaButtonInjectionKey, {
    client: computed(() => props.client),
    site,
    showFreeDialogForSite,
    listenShortcut,
    focusTextarea,
    model,
    currentDialog,
    uploadOnChange,
    uploadAction,
    uploadVoiceAction,
    isFree,
    isCopilotAvailableByTarif,
    sendMessage,
    lastSelectedTemplateText: computed(() => lastSelectedTemplateText),
    uploadCount,
    toggleCopilotRunning,
    showCopilotTimeoutError,
    isCopilotRunning: copilotCommandRunning,
    onTemplateSelect,
    selectedAnswerChannel,
    setReplyToMessageId,
    resetTextareaSelection,
    closeDialog,
    markAsRithoric,
    suggestedTemplates: textareaSuggests,
    selectedSuggestedTemplate: selectedSuggest,
    setSuggestedTemplates: setTextareaSuggests,
    onSuggestedTemplateSelect,
    startVoiceRecord,
    startVoiceTranscribe
});

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (!_unref(OperatorAccountStore).isCabinetIframe || _unref(availableAnswerChannels).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!__props.suggestTemplatesAtBottom)
          ? (_openBlock(), _createBlock(OperatorApplicationSuggestedTemplates, {
              key: 0,
              class: "mb-2"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(['dialog-textarea', `answer-channel-${_unref(model).answerChannelId}`]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(textarea).focus()))
        }, [
          (_unref(editedMessage))
            ? (_openBlock(), _createBlock(OperatorApplicationDialogTextareaAction, {
                key: 0,
                icon: "pencil",
                "cancel-listening": "",
                onCancel: _cache[0] || (_cache[0] = ($event: any) => (cancelEdit()))
              }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(__)("Редактирование")) + ": ", 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(OperatorApplicationHtmlify, {
                    value: _unref(editedMessage).text,
                    bbcode: "",
                    escape: ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(isShowAnswerChannelTabs))
                  ? (_openBlock(), _createBlock(_component_el_tabs, {
                      key: 0,
                      class: "answer-channels",
                      modelValue: _unref(model).answerChannelId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).answerChannelId) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableAnswerChannels), (channel) => {
                          return (_openBlock(), _createBlock(_component_el_tab_pane, {
                            key: channel.id,
                            label: channel.descr,
                            name: channel.id
                          }, {
                            label: _withCtx(() => [
                              _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                _createTextVNode(_toDisplayString(getChannelDescr(channel)), 1)
                              ])), [
                                [_directive_my_tooltip, {delay: 400, text: channel.extraDescr, placement: 'top'}]
                              ])
                            ]),
                            _: 2
                          }, 1032, ["label", "name"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : (!_unref(availableAnswerChannels).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(FontAwesomeIcon, {
                          icon: "exclamation-triangle",
                          class: "mr-2"
                        }),
                        _createTextVNode(" " + _toDisplayString(_unref(__)("Нет доступных каналов отправки сообщения")), 1)
                      ]))
                    : _createCommentVNode("", true)
              ], 64)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ReplyTo),
            _createVNode(AttachmentsList),
            _withDirectives(_createVNode(AnswerChannelSourceSelect, null, null, 512), [
              [
                _directive_on_native,
                void 0,
                "click",
                { stop: true }
              ]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createVNode(TextInputWithVariables, {
                ref_key: "textarea",
                ref: textarea,
                modelValue: _unref(model).text,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).text) = $event)),
                class: "el-textarea__inner",
                "max-height": "calc(100vh - 300px)",
                "min-height": 53,
                placeholder: _unref(placeholder),
                bbcode: _unref(canFormatText),
                "available-bbcode": _unref(availableBBCodeIds),
                inline: "",
                "inline-limited-height": "",
                multiline: "",
                "allow-new-line-at-end": "",
                "auto-focus": "",
                "shift-enter": _unref(sendOnEnter),
                mention: _unref(isMentionsAvailable),
                "content-variables": _unref(contentVariables),
                "show-inline-content-variables": false,
                "prevent-key-up-and-down": _unref(preventKeyUpAndDown),
                onPressEnter: onPressEnter,
                onMentionChange: onMentionChange
              }, null, 8, ["modelValue", "placeholder", "bbcode", "available-bbcode", "shift-enter", "mention", "content-variables", "prevent-key-up-and-down"]), [
                [
                  _directive_on_native,
                  onUpKeyPress,
                  "keyup",
                  { up: true }
                ],
                [
                  _directive_on_native,
                  onDownKeyPress,
                  "keyup",
                  { down: true }
                ],
                [
                  _directive_on_native,
                  onEscKeyPress,
                  "keyup",
                  { escape: true }
                ],
                [_directive_on_native, textareaMouseDown, "mousedown"],
                [_directive_on_native, onPaste, "paste"],
                [_directive_on_native, onFocused, "focus"],
                [_directive_on_native, onFocused, "click"],
                [_directive_on_native, onFocused, "keyup"]
              ]),
              (_unref(OperatorApplicationConfigInstance).symbolCountInTextareaEnabled && _unref(maxTextLength))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass({
                            'text-length-counter': true,
                            [_unref(plainTextLength) > _unref(maxTextLength) ? 'text-danger' : 'text-muted']: true
                        })
                  }, _toDisplayString(_unref(plainTextLength) ?? 0) + " / " + _toDisplayString(_unref(maxTextLength)), 3))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (!_unref(voiceRecordVisible))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(TextareaButtons, {
                      buttons: _unref(textareaButtonsList),
                      left: "",
                      "show-config": !_unref(CoreUiChatHistoryHelper).isOneOfCrossOperatorsChat(__props.client),
                      "unpin-all-buttons": __props.unpinAllButtons
                    }, null, 8, ["buttons", "show-config", "unpin-all-buttons"]),
                    (_unref(copilotTimeoutError))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(FontAwesomeIcon, {
                            icon: "exclamation-triangle",
                            class: "mr-1"
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(__)("Не удалось получить ответ от Copilot")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_unref(translationEnabledAndInProgress))
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createVNode(MyLoader),
                    _createTextVNode(" " + _toDisplayString(_unref(__)("Идёт перевод")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_unref(voiceRecordVisible))
                ? (_openBlock(), _createBlock(VoiceRecorder, {
                    key: 1,
                    visible: _unref(voiceRecordVisible),
                    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(voiceRecordVisible) ? (voiceRecordVisible).value = $event : voiceRecordVisible = $event)),
                    transcribe: _unref(transcribeModeEnabled),
                    username: _unref(username),
                    onTranscribeResult: onTranscribeResult
                  }, null, 8, ["visible", "transcribe", "username"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(TextareaButtons, {
                      buttons: _unref(textareaButtonsList),
                      left: false,
                      "show-config": _unref(CoreUiChatHistoryHelper).isOneOfCrossOperatorsChat(__props.client),
                      "unpin-all-buttons": __props.unpinAllButtons
                    }, null, 8, ["buttons", "show-config", "unpin-all-buttons"]),
                    (!__props.sendFunction && !_unref(editedMessage))
                      ? (_openBlock(), _createBlock(OperatorApplicationDialogTextareaButton, {
                          key: 0,
                          icon: "clock",
                          disabled: !_unref(isReadyToSend),
                          tooltip: _unref(__)('Отправить позже'),
                          "in-dropdown-menu": false,
                          onClick: showDelaySendDialog
                        }, null, 8, ["disabled", "tooltip"]))
                      : _createCommentVNode("", true),
                    (_unref(delaySendDialog) && _unref(delaySendDialog).visible)
                      ? (_openBlock(), _createBlock(OperatorApplicationSendDelayedMessageDialog, {
                          key: 1,
                          visible: _unref(delaySendDialog).visible,
                          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_unref(delaySendDialog).visible) = $event)),
                          site: _unref(site),
                          onInput: delaySend
                        }, null, 8, ["visible", "site"]))
                      : _createCommentVNode("", true),
                    (!_unref(editedMessage))
                      ? (_openBlock(), _createBlock(OperatorApplicationDialogTextareaButton, {
                          key: 2,
                          "icon-style": "transform: translateX(-1px) rotateZ(45deg);",
                          icon: "location-arrow",
                          bold: _unref(isReadyToSend),
                          color: _unref(isReadyToSend) ? 'primary' : null,
                          "in-dropdown-menu": false,
                          onClick: sendMessage,
                          disabled: !_unref(isReadyToSend)
                        }, null, 8, ["bold", "color", "disabled"]))
                      : (_openBlock(), _createBlock(OperatorApplicationDialogTextareaButton, {
                          key: 3,
                          icon: "check",
                          bold: _unref(isReadyToSend),
                          color: _unref(isReadyToSend) ? 'primary' : null,
                          "in-dropdown-menu": false,
                          onClick: saveEdit,
                          disabled: !_unref(isReadyToSend) || !_unref(editedMessage).id
                        }, null, 8, ["bold", "color", "disabled"]))
                  ], 64))
            ])
          ])
        ], 2),
        (__props.suggestTemplatesAtBottom)
          ? (_openBlock(), _createBlock(OperatorApplicationSuggestedTemplates, {
              key: 1,
              class: "mt-2"
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})